import {
  FETCH_MODULE,
  FETCH_MODULE_SUCCESS,
  FETCH_MODULE_FAILURE,
  FETCH_MODULE_PROJECT_CLIENT_SERVICE,
  FETCH_MODULE_PROJECT_CLIENT_SERVICE_SUCCESS,
  FETCH_MODULE_PROJECT_CLIENT_SERVICE_FAILURE, 
  FETCH_MODULE_PROJECT_CLIENT_SERVICE_CLEAR, 
  SAVE_MODULE,
  SAVE_MODULE_SUCCESS,
  SAVE_MODULE_FAILURE,
  CHANGE_MODULE_STATUS,
  CHANGE_MODULE_STATUS_SUCCESS,
  CHANGE_MODULE_STATUS_FAILURE
} from "./actionTypes";

// Fetch Module
export const fetchModule = (payload) => ({
  type: FETCH_MODULE,
  payload
});

export const fetchModuleSuccess = (roles) => ({
  type: FETCH_MODULE_SUCCESS,
  payload: roles,
});

export const fetchModuleFailure = (error) => ({
  type: FETCH_MODULE_FAILURE,
  payload: error,
});

export const fetchModuleProjectClientService = (payload) => ({
  type: FETCH_MODULE_PROJECT_CLIENT_SERVICE,
  payload: payload
});

export const fetchModuleProjectClientServiceSuccess = (roles) => ({
  type: FETCH_MODULE_PROJECT_CLIENT_SERVICE_SUCCESS,
  payload: roles,
});

export const fetchModuleProjectClientServiceFailure = (error) => ({
  type: FETCH_MODULE_PROJECT_CLIENT_SERVICE_FAILURE,
  payload: error,
});

export const fetchModuleProjectClientServiceClear = () => ({
  type: FETCH_MODULE_PROJECT_CLIENT_SERVICE_CLEAR,
  payload: '',
});

// Create Project
export const saveModule = (formData, isEdit) => ({
  type: SAVE_MODULE,
  payload: { formData, isEdit },
});

export const saveModuleSuccess = (response) => ({
  type: SAVE_MODULE_SUCCESS,
  payload: response,
});

export const saveModuleFailure = (error) => ({
  type: SAVE_MODULE_FAILURE,
  payload: error,
});

export const changeModuleStatus = (payload) => ({
  type: CHANGE_MODULE_STATUS,
  payload,
});

export const changeModuleStatusSuccess = (response) => ({
  type: CHANGE_MODULE_STATUS_SUCCESS,
  payload: response,
});

export const changeModuleStatusFailure = (error) => ({
  type: CHANGE_MODULE_STATUS_FAILURE,
  payload: error,
});

